import { suspensionDateStatus } from 'constants/suspensionConstants';
import { createReducer, makeActionCreator } from 'utils/reduxCreators';
import { fetchSuspensionInfo, fetchSuspension } from 'services/suspensions';
import { updateAppLoading } from './meta';

export const RECEIVED_SUSPENSION_INFO = 'suspensions/RECEIVED_SUSPENSION_INFO';
export const RECEIVED_SUSPENSION = 'suspensions/RECEIVED_SUSPENSION';
export const UPDATE_SUSPENSION_RULE_LOADER =
  'suspensions/UPDATE_SUSPENSION_RULE_LOADER';

const initialState = {
  suspensionInfo: {},
  currentSuspension: {},
  hasSuspensionRuleForAccount: false,
  canChargeForSuspension: false,
  suspensionRuleLoading: false,
};

export default createReducer(initialState, {
  [RECEIVED_SUSPENSION_INFO]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  },
  [RECEIVED_SUSPENSION]: (state, { payload }) => {
    return {
      ...state,
      currentSuspension: payload,
    };
  },
  [UPDATE_SUSPENSION_RULE_LOADER]: (state, { payload }) => {
    return {
      ...state,
      suspensionRuleLoading: payload,
    };
  },
});

export const getSuspensionInfo = (
  adfitNo,
  canSuspendIgnoreSuspensionRules,
  suspensionStartDate,
  isMandatedSuspension
) => async (dispatch) => {
  dispatch(updateSuspensionRuleLoading(true));
  try {
    const suspensionInfo = await fetchSuspensionInfo(
      adfitNo,
      suspensionStartDate
    );
    dispatch(updateSuspensionRuleLoading(false));
    const {
      allowedSuspensionPeriod,
      remainingSuspensionPeriod,
      suspensionFee,
    } = suspensionInfo;

    const hasSuspensionRuleForAccount = !(
      allowedSuspensionPeriod === null &&
      remainingSuspensionPeriod === null &&
      suspensionFee === null
    );

    dispatch({
      type: RECEIVED_SUSPENSION_INFO,
      payload: {
        suspensionInfo,
        hasSuspensionRuleForAccount,
        //In the following three situations, users can disregard the suspension rule and charge for suspension.
        //1. The user has the "CanSuspendIgnoreSuspensionRules" permission.
        //2. The facility account of the suspended user does not have a suspension rule set.
        //3. The modified suspension is mandated.This situation only occurs on the editing page; suspensions added through SS NEW are always non-mandated.
        canChargeForSuspension:
          canSuspendIgnoreSuspensionRules ||
          !hasSuspensionRuleForAccount ||
          isMandatedSuspension,
      },
    });
  } catch (e) {
    dispatch(updateSuspensionRuleLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};

export const getSuspension = (adfitNo, scheduleSuspenseId) => async (
  dispatch
) => {
  dispatch(updateAppLoading(true));
  try {
    const suspension = await fetchSuspension(adfitNo, scheduleSuspenseId);
    dispatch(updateAppLoading(false));
    dispatch({
      type: RECEIVED_SUSPENSION,
      payload: {
        ...suspension,
        isFuture:
          suspension.suspensionDateStatus === suspensionDateStatus.Future,
        isOngoing:
          suspension.suspensionDateStatus === suspensionDateStatus.Ongoing,
        isExpired:
          suspension.suspensionDateStatus === suspensionDateStatus.Expired,
      },
    });
    return Promise.resolve(suspension);
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};

export const updateSuspensionRuleLoading = makeActionCreator(
  UPDATE_SUSPENSION_RULE_LOADER
);
